import React from 'react';
import { ToastContainer } from 'react-toastify';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { InfoModal, BlockedTrober, ThemeProvider } from './Containers';
import { WaitBlock } from './UI';
import RDC, { RDCType } from './Utils/Develop';
import App from './App';
import 'moment/locale/ru';
import store from './store';
import Guid from './Utils/Guid';
import i18next, { initI18next } from './i18n';
import APICookies from './API/Cookies';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './Themes/MainApp.scss';

declare global {
	interface Window {
		Opal: any;
		Stimulsoft: any;
		RDC: RDCType;
		isDev: boolean;
		cadesplugin?: any;
		devHost: string;
		host: string;
		authURLRedirect: string;
		mainURLRedirect: string;
		cfg: {
			logRedux: boolean;
		};
		hostObject: {};
		Guid: typeof Guid;
	}
}

/** Тут глобально настраиваем приложение... */
const globalConfig = () => {
	// Настраиваем всякие хэлперы...
	window.RDC = RDC;
	const url = new URL(window.location.href);
	window.host = url.origin;
	window.isDev = process.env.NODE_ENV === 'development';
	window.cfg = {
		logRedux: false,
	};
	// Куда уходить после логина- сразу на главную нового UI
	window.mainURLRedirect = '#/portal/fileList';

	// Тут зададим пути для отладочного режима и продуктивного
	if (window.isDev) {
		console.warn(process.env.NODE_ENV + ' mode.');
		window.host = process.env.REACT_APP_API_UR || 'http://localhost:29929';
		window.devHost =
			process.env.REACT_APP_FRONT_URL || 'http://localhost:3000';
		window.authURLRedirect = '/#/login';
	} else {
		window.authURLRedirect = '/new#/login';
		window.devHost = window.location.origin;
	}

	// Инициализация языкового движка
	initI18next();
	// Получаем куки от сервера с указанием языка
	const lang = APICookies.get('lang', 'dev') || 'dev';
	// Устанавливаем язык
	i18next.changeLanguage(lang);
};

const container = document.getElementById('root');
const root = createRoot(container!);

globalConfig();

root.render(
	<React.Suspense fallback={<WaitBlock center />}>
		<ThemeProvider>
			<Provider store={store}>
				<App />
				<ToastContainer />
				<InfoModal />
				<BlockedTrober />
			</Provider>
		</ThemeProvider>
	</React.Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
